import React from 'react';

import { isUserInSubUnitChecker } from '@modules/advancement/pendingItems/utils';
import { Tooltip } from '@modules/shared';

interface PendingItemsCustomRow {
  children?: React.ReactNode;
}

const PendingItemsCustomRow: React.FC<PendingItemsCustomRow> = props => {
  const { children } = props;

  // check if children is undefined or null or not an array
  // check if first array exist and has props
  if (
    !children ||
    !Array.isArray(children) ||
    !children[0] ||
    !('props' in children[0])
  ) {
    return <tr {...props}>{children}</tr>;
  }

  const { record } = children[0].props;

  return isUserInSubUnitChecker(record) ? (
    <tr {...props} />
  ) : (
    <Tooltip
      title={`Position does not grant permission to approve.`}
      placement="top"
    >
      <tr {...props} />
    </Tooltip>
  );
};

export default PendingItemsCustomRow;
